export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
};

/**
 * Приводит значение к конечному числу.
 *
 * В денежном поле с сервера может прийти строка, null или величина, которая
 * не помещается в double. Без приведения такое значение рисуется как NaN,
 * а точка с NaN ломает всю ось графика.
 */
export const toFiniteNumber = (value) => {
    const number = typeof value === "number" ? value : Number(value);

    return Number.isFinite(number) ? number : 0;
};

/**
 * Денежный формат: разряды и не больше двух знаков после запятой.
 * Знак валюты рисует PriceWithCurrency, здесь только число.
 */
export const formatMoney = (value, locale = "ru-RU") =>
    new Intl.NumberFormat(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(toFiniteNumber(value));
